<template>
    <div>
        <a class="header-top__button header-top__button--location header-top__button--location-epp" data-popup-open="city-dropdown-mob">
            <span class="header-top__button-text js-header-city">
                {{ getSelectedCity.Name }}
            </span>
            <span class="header-top__button-icon auth-icon-active">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.0005 9.68606C10.1366 9.68606 11.0576 8.76505 11.0576 7.62892C11.0576 6.49279 10.1366 5.57178 9.0005 5.57178C7.86437 5.57178 6.94336 6.49279 6.94336 7.62892C6.94336 8.76505 7.86437 9.68606 9.0005 9.68606Z" stroke="white" stroke-width="1.42857" stroke-linecap="square"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00036 15.8574C12.6346 12.5854 14.4861 9.80079 14.4861 7.71232C14.4861 4.63651 12.03 2.14307 9.00036 2.14307C5.97069 2.14307 3.51465 4.63651 3.51465 7.71232C3.51465 9.80079 5.36608 12.5158 9.00036 15.8574Z" stroke="white" stroke-width="1.42857" stroke-linecap="square"></path>
                </svg>
            </span>
        </a>

        <div class="lit-popup lc-modal js-outer-popup lc-modal--city" data-popup="city-dropdown-mob" data-barba-prevent="all">
            <div class="modal__overlay" data-popup-close="city-dropdown-mob" style="display: none;"></div>
            <div class="modal__overlay-cookies js-modal__overlay-cookies"></div>

            <div class="lc-modal--city-wrapper" style="left: 100%;">
                <div class="city-popup__form js-city-form">
                    <input type="hidden" name="mode" value="">
                    <input type="hidden" name="action" value="setGeo">
                    <div class="city-popup__head">
                        <div class="city-popup__title">
                            Ваш город
                        </div>
                        <button type="button" class="city-popup__close js-city-popup-close" data-popup-close="city-dropdown-mob">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 2L18 18M2 18L18 2" stroke="black" stroke-width="1.5"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="city-popup__ctrl select-drop city-select js-select-wrapper">
                        <select class="js-select-city" id="CityPicker" name="geo" data-id="ss-z7rfsl3i" tabindex="-1" aria-hidden="true" style="display: none;" v-model="selectedCityOption">
                            <option v-for="city in cities" v-bind:key="city.ShortName" v-bind:value="city.ShortName" :disabled="!city.Enabled" v-if="city.isVisible">
                                <span v-if="city.Enabled">{{ city.Name }}</span>
                                <span v-else style="color: grey;">{{ city.Name }}</span>
                            </option>
                        </select>
                        <div data-id="ss-z7rfsl3i" aria-label="Combobox" tabindex="0" class="ss-main js-select-city ss-open-below ss-open" role="combobox" aria-haspopup="listbox" aria-controls="" aria-expanded="true"><div class="ss-values"><div class="ss-placeholder">Select Value</div></div><div class="ss-deselect ss-hide"><svg viewBox="0 0 100 100"><path d="M10,10 L90,90 M10,90 L90,10"></path></svg></div><svg class="ss-arrow ss-hide" viewBox="0 0 100 100"><path d="M10,70 L50,30 L90,70"></path></svg></div>
                        <div id="js-select-city__list">
                            <div data-id="ss-z7rfsl3i" class="ss-content js-select-city ss-relative ss-open-below" role="listbox" style="margin: -1px 0px 0px;">
                                <div class="ss-list">
                                    <!--<div class="ss-option ss-hide"></div>-->
                                    <div v-for="city in cities" class="ss-option" role="option" aria-selected="false" v-model="selectedCityOption" v-if="city.isVisible" @click="changeCity(city.ShortName)" v-bind:id="city.Id" :class="!city.Enabled ? 'is-disabled' : ''">{{ city.Name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="city-popup__bottom visually-hidden js-city-popup__bottom">
                    <div class="city-popup__cookie">
                        <!-- Продолжая пользоваться сайтом, вы даёте <a href="/personal-data/" target="_blank" class="city-popup__cookie-link">согласие</a> на автоматический сбор и анализ ваших данных, необходимых для работы сайта и его улучшения, использование файлов cookie. -->
                        Продолжая использование данного сайта, Вы&nbsp;выражаете своё
                        <a href="/personal-data/" target="_blank" class="city-popup__cookie-link">согласие на автоматический сбор, анализ и обработку своих персональных данных и </a>метаданных (cookie, данные об&nbsp;IP-адресе и&nbsp;местоположении) для корректного отображения страниц сайта.
                        В&nbsp;случае несогласия Вы&nbsp;можете обратиться в <a href="https://sibgenco.services/UL/helpinfo/kontakty-i-adresa-cok#contactSection_3" target="_blank" class="city-popup__cookie-link">центр обслуживания клиентов</a> вашего города.
                    </div>
                    <div class="city-popup__button">
                        <!-- <button class="city-popup__btn js-city-popup-close " data-popup-close="city-dropdown">Ок</button> -->
                        <button type="button" class="city-popup__btn js-city-popup-close js-city-accept-cookie">Ок</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { getCookie, setCookie, splitDot } from "../../../wwwroot/app/epp.utils.js"
    let splittedCurrentUrl = splitDot(document.location.hostname);
    let cityCookie;
    if (getCookie("city") !== undefined) {
        cityCookie = splitDot(getCookie("city"));
    }
    let currentProtocol = document.location.protocol + "//";

    export default {
        data: function () {
            return {
                cities: null,
                selectedCity: "",
                selectedCityOption: null,
                selectedCityOptionShortName: null,
                agreement: false,
                urlCityExists: false
            }
        },
        created: function () {
            this.cities = JSON.parse(this.all_cities);
            this.urlCityExists = !!this.cities.some(item => item.ShortName === splittedCurrentUrl[0]);
            this.selectedCityOption = this.selected_сity_short_name;
            if (!!getCookie) this.agreement = !!getCookie("agreement");
            console.log("Выбранный город", this.selectedCityOption);
            console.log("CITY COOKIE", cityCookie);
            console.log("URL", this.urlCityExists);
            if (cityCookie === undefined) {
                this.selectedCity = "Выберите ваш город"
                this.callCityPicker();
            }
            else {
                this.selectedCity = this.selected_сity;
            }

            this.setAccessFirstLevelButtons();
        },
        props: {
            selected_сity_name: String,
            selected_сity_short_name: String,
            all_cities: String
        },
        computed: {
            getCities() {
               return this.cities
            },
            getSelectedCity() {
                console.log("SELECTED CITY", this.cities.find(item => item.ShortName == this.selectedCityOption));
                return this.cities.find(item => item.ShortName == this.selectedCityOption)  
            }
        },
        updated() {
            this.changeCity(this.getSelectedCity.ShortName)
        },
        methods: {
            saveAgreement: function () {
                setCookie("agreement", true);
                this.agreement = true;
            },
            changeCity: function (value) {

                console.log("VALUE", value);
                console.log("splittedCurrentUrl", splittedCurrentUrl);
                if (splittedCurrentUrl.length < 2) {
                    this.setAccessFirstLevelButtons();

                    return;
                }

                this.selectedCityOption = value;
                
                setCookie("city", `.${this.selectedCityOption}`);
                console.log("SELECTED CITY SET COOKIE", this.selectedCityOption);
                this.goToNewUrl(this.assemblingNewUrl(splittedCurrentUrl, currentProtocol, value, this.urlCityExists));
            },
            callCityPicker: function () {
                $(document).ready(function () {
                    $("#dropCityPicker").addClass("is-open");
                });
            },
            assemblingNewUrl(splittedCurrentUrl, currentProtocol, selectedCity, urlCityExists) {
                let result = currentProtocol;
                if (urlCityExists) {
                    splittedCurrentUrl[0] = selectedCity
                }
                else {
                    splittedCurrentUrl.unshift(selectedCity)
                }
                if (splittedCurrentUrl[0] == splittedCurrentUrl[1]) {
                    splittedCurrentUrl.splice(1, 1);
                }
                splittedCurrentUrl.forEach(item => result += item + ".");
                result = result.slice(0, -1) + document.location.pathname;
                return result;
            },
            goToNewUrl(url) {
                if (document.location.href != "localhost") {
                    document.location = url
                }
            },
            setAccessFirstLevelButtons() {
                console.log(this.getSelectedCity);
                let curcity = this.getSelectedCity;

                let nav1_FL = document.getElementById('a_nav1_fl');
                let nav1_UL = document.getElementById('a_nav1_ul');
                let nav1_STS = document.getElementById('a_nav1_sts');

                if (curcity.isFL)
                {
					if (nav1_FL)  nav1_FL.classList.remove('disabled');
                }
                 else
                {
					if (nav1_FL)  nav1_FL.classList.add('disabled');
                }

                if (curcity.isUL)
                {
					if (nav1_UL) nav1_UL.classList.remove('disabled');
                }
                else
                {
					if (nav1_UL)  nav1_UL.classList.add('disabled');
                }

                if (curcity.isSTS) {
					if (nav1_STS)  nav1_STS.classList.remove('disabled');
                }
                else
                {
					if (nav1_STS)  nav1_STS.classList.add('disabled');
                }
            }
        }
    }
</script>

<style scoped>
    .is-disabled {
        pointer-events: none;
        cursor: not-allowed;
    }
</style>


// WEBPACK FOOTER //
// Scripts/app/CityPicker/CityPickerMobile.vue